<template>
    <div>
        <v-dialog v-model="progressDialog" width="300" persistent>
            <v-card>
                <v-card-text>
                    Uploading your file...<br>
                    <v-progress-linear :indeterminate="true"></v-progress-linear>
                </v-card-text>
            </v-card>
        </v-dialog>
    </div>
</template>
<script>

    export default {
        name: 'ProgressDialog',
        components: {},
        // props: ['progressDialog'],
        data() {
            return {
                progressDialog: true,
            }
        },
    }
</script>



// WEBPACK FOOTER //
// src/components/Common/ProgressDialog.vue